import { createContext } from "react"

const AccessUsersContext = createContext();

export default AccessUsersContext;